import { env } from '../../utils/env';
import { filters } from './mapFilters';
import { services } from './services';

const store = {
  state: {
    page: null,
    service: null,
    city: null,
    age: null,
    robot: null,
    locationId: null,
    occurrence: null,

    tips: {
      mapFilter: true,
    },

    map: {
      center: null,
      zoom: null,
      filters: filters,
    },

    contactForm: {
      name: { text: '', valid: false },
      date: { text: null, valid: false },
      email: { text: '', valid: false },
      phone: { text: '', valid: false },
      address: { text: '', valid: false },
      knownClient: { text: '', valid: false },
      paymentType: { text: '', valid: false },
      postalCode: { text: '', valid: false },
      streetAddress: { text: '', valid: false },
      parentFullName: { text: '', valid: false },
      city: { text: '', valid: false },
      comment: { text: '', valid: true },
      schoolClass: {text: "", valid: true },
      promoCoupon: { text: '', valid: false },
    },

    agreements: null,
  },

  data: {
    steps: 5,
    franchises: null,
    groups: null,
    workshops: null,
    summerplayTypes: null,
    consents: null,

    logoSrc: `${env.PUBLIC_URL}/assets/images/go4robot.png`,
    mainTitleDescription: {
      title: 'Formularz zapisów',
      description: 'Wszystkie warsztaty w jednym miejscu',
    },
    mainTitleDescriptionAlt: 'Twoje wybory',
    filterMenuText: 'Filtrowanie',
    generalTiles: [
      {
        type: 1,
        title: 210,
        image: `${process.env.PUBLIC_URL}/assets/icons/szkoly.svg`,
        description: 'Szkół i placówek',
      },
      {
        type: 1,
        title: "8 lat",
        image: `${process.env.PUBLIC_URL}/assets/icons/lata.svg`,
        description: 'Doświadczenia',
      },
      {
        type: 1,
        title: 6000,
        image: `${env.PUBLIC_URL}/assets/icons/zadowolonych.svg`,
        description: 'zadowolonych dzieci',
      },
    ],
    cityFormLabel: 'Wybierz miasto',
    serviceFormLabel: 'Wybierz usługę',
    services: services,
    formFieldErrors: {
      name: 'Błędne imię i nazwisko',
      email: 'Błędny adres e-mail',
      phone: 'Błędny numer telefonu',
      date: 'Czy na pewno Twoje dziecko jest pełnoletnie?',
      paymentType: 'Błędny typ płatności',
      streetAddress: 'Błędny adres',
      postalCode: 'Błędny kod pocztowy - poprawny format 00-000',
      city: 'Błędna nazwa miasta',
    },
    formPageSingle: {
      locationLabel: 'Wybrana lokalizacja',
      mainLabel: 'Wybierz grupę z listy',
    },
    formPage: {
      mainLabel: 'Dane kontaktowe',
      offerText: 'Propozycja lokalizacji',
      nameLabel: 'Dziecko: Imię i nazwisko',
      nameHint: 'Jaś Kowalski',
      datapickerLabel: 'Dziecko: Data urodzenia',
      datapickerHint: '01/01/2016',
      weekDaysLabel: 'Wybierz dni turnusu',
      emailLabel: 'Adres e-mail',
      emailHint: 'jan.kowalski@gmail.com',
      phoneLabel: 'Telefon',
      phoneHint: '000-000-000',
      knownClientLabel: 'Czy korzystałeś z usług GO4Robot?',
      knownClientHint: 'wybierz opcję:',
      schoolClassLabel: "Klasa/Grupa przedszkolna",
      commentLabel: 'Dodatkowy komentarz',
      errorInfo: 'Coś poszło nie tak.',
      whyData:
        'Zbieramy dane do umowy, aby uprościć proces zapisu. Umowa podpisywana jest dopiero po pierwszych zajęciach. Do tego momentu można nieodpłatnie zrezygnować.',
    },
    servicePage: {
      placeholder: 'wiek:',
    },
    agePage: {
      placeholder: 'wiek:',
    },
    cityPage: {
      placeholder: 'Wpisz nazwę miasta',
    },
    mapPage: {
      suggestion: 'Zaproponuj miejsce',
      PERIODIC: 'Zajęcia cykliczne',
      DEMO: 'Lekcja pokazowa',
      dayText: 'Grupa',
      locationPlaceholder: 'Wpisz nazwę lokalizacji',
      locationHeader: 'Wybierz lokalizację',
      levelHeader: 'Wybierz poziom',
    },
    singleInputPage: {
      descriptions: ['Usługa', 'Miasto', 'Wiek dziecka'],
    },
    robotAccordion: {
      description1: 'Wiek:',
      description2: 'Cena:',
      description3: 'Czas trwania:',
      secondary: 'Dowiedz się więcej',
      primary: 'Przejdź do mapy',
    },
    selectOptionInfo: {
      description1: 'Wiek:',
      description2: 'Czas trwania:',
      title: 'Tytuł',
      secondary: 'Dowiedz się więcej',
      primary: 'Przejdź do mapy',
    },
    mapMarkers: {
      standard: `${env.PUBLIC_URL}/assets/icons/map.svg`, // unused
      selected: `${env.PUBLIC_URL}/assets/icons/map-s.svg`, //unused
    },
    newIcons: {
      coinFree: `${env.PUBLIC_URL}/assets/icons/coins_free.svg`,
      coinZl: `${env.PUBLIC_URL}/assets/icons/coin_zl.svg`,
      school: `${env.PUBLIC_URL}/assets/icons/szkoly.svg`,
      robot: `${env.PUBLIC_URL}/assets/icons/lata.svg`,
      hours: `${env.PUBLIC_URL}/assets/icons/hours.svg`,
    },
    selectOptionMap: {
      placeholder: 'wybierz termin:',
      descriptions: [
        'Pierwsza lekcja niezobowiązująca',
        'Liczba osób',
        'Start',
        'Cena zajęć',
        'Cena turnusu',
        'Typ zajęć',
        'Czas trwania zajęć'
      ],
      defaults: ['Przetestuj', '0/0', 'Data', 'Cena'],
      errorInfo: 'Nieustalone',
      title: 'Informacje',
      warning:
        'Zapisy pod adresem: <a href="mailto:zapisy@g4r.pl">zapisy@g4r.pl</a>',
      onlyInternalSignups:
        'Ta placówka przyjmuje tylko dzieci uczęszczające do niej. Możesz się zapisać używając kodu dostępnego na plakacie w placówce.',
    },
    summerplayTexts: {
      summerplay: 'Półkolonie',
      summerplayWorkshops: 'Warsztaty wakacyjne',
    },
    // TODO use those texts instead of hardcoding
    mapLegend: {
       allChildren: "Placówka przyjmuje wszystkie dzieci.",
       onlyLocalChildren: "Placówka przyjmuje tylko dzieci uczęszczające do niej.",
    },
    sendText: 'Wyślij',
    nextText: 'Dalej',
    chooseText: 'Wybierz',
    serviceErrorMessage:
      'Na ten moment nie mamy tej usługi. Zadzwoń: 123-456-789',
    levelErrorMessage: 'Na ten moment nie mamy zajęć dla tej grupy wiekowej.',
    noWorkshopErrorMessage:
      'Obecnie nie ma grup o wybranym poziomie :(<br />Wybierz inny poziom w filtrach lub zaproponuj miejsce zajęć!',
    noSummerplayErrorMessage: 'Obecnie nie ma grup w tym mieście :(',
    robotFormLabel: 'Propozycje',
    ageFormLabel: 'Wybierz wiek dziecka',

    thankYou: 'Dziękujemy!',
    thankYouTitle: 'Twoje zgłoszenie zostało przesłane!',
    thankYouDescriptionF:
      'Z uwagi na ogromną ilość zgłoszeń, może to troche potrwać.',
    thankYouDescriptionS: 'Postaramy się odezwać tak szybko - jak to możliwe!',
    workshopsCurrentLocation: null,
    paymentOptions: [
      {
        key: 1,
        value: 'kindergarden_vat_invoice',
        text: 'Płatność w przedszkolu',
      },
      { key: 2, value: 'parent_monthly', text: 'Płatność miesięczna' },
      { key: 3, value: 'parent_by_semester', text: 'Płatność semestralna' },
      { key: 4, value: 'payment_yearly', text: 'Płatność roczna' },
    ],
  },
};

export default store;
